import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { designSystem } from '@yola/ws-ui';
import setHeight from '../actions/set-height';
import NavbarContainer from '../../navbar/containers/navbar-container';
import ReadOnlyBannerContainer from '../../read-only-mode/container/read-only-banner-container';

const { EditorHeader } = designSystem;

const TopbarContainer = () => {
  const dispatch = useDispatch();
  const topbarRef = useRef(null);
  const [currentHeight, setCurrentHeight] = useState(0);

  const resizeObserver = new ResizeObserver((entries) => {
    setCurrentHeight(
      entries.reduce((acc, entrie) => acc + entrie.contentRect.height, currentHeight)
    );
  });

  useEffect(() => {
    const topbarElement = topbarRef.current;
    resizeObserver.observe(topbarElement);

    return () => resizeObserver.unobserve(topbarElement);

    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const navbarHeight = EditorHeader.getHeight();
    document.body.style.setProperty('--ws-editor-navbar-height', `${navbarHeight}px`);
    document.body.style.setProperty('--ws-editor-topbar-height', `${currentHeight}px`);

    dispatch(setHeight(currentHeight));
  }, [dispatch, currentHeight]);

  return (
    <div ref={topbarRef}>
      <ReadOnlyBannerContainer />
      <NavbarContainer />
    </div>
  );
};

export default TopbarContainer;
